import React from "react";
import { Checkbox, Col, Row, Select, Tooltip } from "antd";
import { Option } from "antd/es/mentions";
import { useTranslation } from "react-i18next";
import InputText from "../Input/InputText";
import EditorText from "../EditorText";
import "../../../assets/style/modalStyle/postNews.scss";
import LabelInput from "../LabelInput";
import { DatePicker } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { pupSelector } from "../../../services/selector/index.";
import { deleteGroupTime } from "../../../services/slice/DealSlice";
import { useDispatch } from "react-redux";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import UpImageEdit from "../Button/UpImageEdit";
import { useState } from "react";
import { useEffect } from "react";
import TranslateText from "../TranslateText";
import ModalDelete from "../Modal/delete/ModalDelete";
import ModalSelectGroupCustomer from "../Modal/other/ModalSelectGroupCustomer";
import { IconEdit, IconPen } from "../../../assets/icon";
const TabDeals = ({ datapost, setDataPost, setImage, error, img, addPost }) => {
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [showSelectGroup, setShowSelectGroup] = useState(false);
  const [valueSelectUsed, setValueSelectUsed] = useState([]);
  const [valueSelectValid, setValueSelectValid] = useState([]);
  const [valueSelectExpired, setValueSelectExpired] = useState([]);
  const [valueSelectNumberMachine, setValueSelectNumberMachine] = useState([]);
  useEffect(() => {
    if (datapost.title) {
      setIsEdit(true);
    }
  }, []);
  const dateFormat = "YYYY-MM-DD HH:mm:ss";
  useEffect(() => {
    let arrUse = [];
    let arrValid = [];
    let arrExpired = [];
    let arrNumberMachine = [];
    if (datapost?.attractGroupDetail?.length) {
      datapost?.attractGroupDetail.map((item) => {
        if (item.typeGroup === 1) {
          arrUse.push(item.id);
        } else if (item.typeGroup === 2) {
          arrValid.push(item.id);
        } else if (item.typeGroup === 3) {
          arrExpired.push(item.id);
        } else arrNumberMachine.push(item.id);
        setValueSelectExpired(arrExpired);
        setValueSelectNumberMachine(arrNumberMachine);
        setValueSelectUsed(arrUse);
        setValueSelectValid(arrValid);
      });
    }
  }, [datapost?.attractGroupDetail, datapost?.attractGroupDetail?.length]);

  const handleDelete = () => {
    dispatch(deleteGroupTime(dataDelete.id));
    dispatch(
      setOpenPUDelete({
        stateOpen: false,
        content: "",
        id: "",
      })
    );
  };

  return (
    <>
      {showSelectGroup ? (
        <ModalSelectGroupCustomer
          valueSelectExpired={valueSelectExpired}
          valueSelectNumberMachine={valueSelectNumberMachine}
          setValueSelectExpired={setValueSelectExpired}
          setValueSelectNumberMachine={setValueSelectNumberMachine}
          setValueSelectUsed={setValueSelectUsed}
          setValueSelectValid={setValueSelectValid}
          valueSelectUsed={valueSelectUsed}
          valueSelectValid={valueSelectValid}
          setDataPost={setDataPost}
          open={showSelectGroup}
          setOpen={setShowSelectGroup}
        />
      ) : null}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa nhóm"
          title="Xóa nhóm"
          width={680}
        />
      )}
      <Row align={"middle"}>
        <Col span={2}>
          <LabelInput text={"Tiêu đề"} />
        </Col>
        <Col span={22}>
          <InputText
            maxLength={155}
            focus
            key={"inputTitle"}
            text={datapost.title}
            setText={(value) => setDataPost({ ...datapost, title: value })}
            placeholder={"Nhập tiêu đề bài viết"}
            typeInput={`${
              !datapost.title && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      <Row style={{ margin: "1.5rem 0" }} align={"middle"}>
        <Col span={2}>
          <LabelInput text={"Mô tả"} />
        </Col>
        <Col span={22}>
          <InputText
            text={datapost.descriptions}
            setText={(value) =>
              setDataPost({ ...datapost, descriptions: value })
            }
            placeholder={"Nhập mô tả"}
            typeInput={`${
              !datapost.descriptions && error.isError ? "checkEmptyText" : null
            }`}
          />
        </Col>
      </Row>
      <Row
        style={{
          marginBottom: "1.5rem",
          display: "flex",
          alignItems: datapost.typePost === 1 ? "" : "center",
        }}
      >
        <Col span={2}>
          <LabelInput
            text={datapost.typePost === 1 ? "Nội dung" : "Link bài viết"}
          />
        </Col>
        <Col span={22}>
          {datapost.typePost === 1 ? (
            <EditorText
              text={datapost.content}
              height={180}
              placeholder={"Nhập nội dung bài viết"}
              setText={setDataPost}
              type={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : null
              }`}
            />
          ) : (
            <InputText
              text={datapost.content}
              setText={(value) => setDataPost({ ...datapost, content: value })}
              placeholder={"Nhập đường dẫn bài viết"}
              typeInput={`${
                (!datapost.content && error.isError) ||
                error.msg === "Đường dẫn không hợp lệ"
                  ? "checkEmptyText"
                  : null
              }`}
            />
          )}
        </Col>
      </Row>
      <Row justify={"end"}>
        <Col span={22}>
          <Row justify={"space-between"}>
            <Col span={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // justifyContent: "center",
                  width: "160px",
                  alignItems: "center",
                }}
              >
                <span className="titleArea">
                  <TranslateText text={"Vùng 1"} />
                </span>
                <UpImageEdit
                  setImage={setImage}
                  width={"160px"}
                  height={"110px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={img}
                  setDataPost={setDataPost}
                  widthImage={623}
                  heightImage={434}
                  url={datapost.firstImage}
                  setFile={(value) => {
                    setDataPost({ ...datapost, firstImage: value });
                  }}
                  style={
                    addPost && !img && error.isError
                      ? { border: "1px solid red" }
                      : null
                  }
                />
                <span className="noteSize">
                  (<TranslateText text={"Kích thước"} /> ảnh gốc)
                </span>
              </div>
            </Col>
            <Col span={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "160px",
                  // justifyContent: "center",
                  // border: "1px solid",
                  alignItems: "center",
                }}
              >
                <span className="titleArea">
                  <TranslateText text={"Vùng 2"} />
                </span>
                <UpImageEdit
                  setImage={setImage}
                  width={"160px"}
                  height={"110px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={img}
                  setDataPost={setDataPost}
                  widthImage={373}
                  heightImage={205}
                  url={datapost.secondImage}
                  setFile={(value) => {
                    setDataPost({ ...datapost, secondImage: value });
                  }}
                  style={
                    addPost && !img && error.isError
                      ? { border: "1px solid red" }
                      : null
                  }
                />
                <span className="noteSize">
                  (<TranslateText text={"Kích thước"} /> 373x205)
                </span>
              </div>
            </Col>
            <Col span={4}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // justifyContent: "center",
                  // border: "1px solid",
                  width: "160px",
                  alignItems: "center",
                }}
              >
                <span className="titleArea">
                  <TranslateText text={"Vùng 3"} />
                </span>
                <UpImageEdit
                  setImage={setImage}
                  width={"160px"}
                  height={"110px"}
                  accept={".png, .jpg, .jpeg, .gif"}
                  image={img}
                  setDataPost={setDataPost}
                  widthImage={220}
                  heightImage={154}
                  url={datapost.thirdImage}
                  setFile={(value) => {
                    setDataPost({ ...datapost, thirdImage: value });
                  }}
                  style={
                    addPost && !img && error.isError
                      ? { border: "1px solid red" }
                      : null
                  }
                />
                <span className="noteSize">
                  (<TranslateText text={"Kích thước"} /> 220x154)
                </span>
              </div>
            </Col>
            <Col span={12}>
              {!addPost ? (
                <Row
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  align={"middle"}
                  justify={"space-between"}
                >
                  <Col span={2}></Col>
                  <Col span={15}>
                    <LabelInput
                      text={"Hiển thị lại notify cho khách hàng"}
                      style={{
                        textAlign: "left",
                        paddingRight: 0,
                      }}
                    />
                  </Col>
                  <Col span={7}>
                    <Checkbox
                      checked={datapost.lastUpdate === 1}
                      onChange={() => {
                        setDataPost({ ...datapost, lastUpdate: 1 });
                      }}
                    ></Checkbox>
                  </Col>
                </Row>
              ) : null}
              <Row
                style={{ width: "100%" }}
                align={"middle"}
                justify={"space-between"}
              >
                <Col span={10}>
                  <LabelInput text={"Thời gian bắt đầu"} />
                </Col>
                <Col span={14}>
                  <DatePicker
                    // value={datapost?.timeStart}
                    format={"DD/MM/YYYY HH:mm:00"}
                    defaultValue={
                      datapost.timeStart
                        ? moment(datapost.timeStart, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeStart ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeStart: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                    placeholder={t("Chọn thời gian")}
                  />
                </Col>
              </Row>
              <Row
                style={{ width: "100%", margin: "1.5rem 0" }}
                align={"middle"}
                justify={"space-between"}
              >
                <Col span={10}>
                  <LabelInput text={"Thời gian kết thúc"} />
                </Col>
                <Col span={14}>
                  <DatePicker
                    format={"DD/MM/YYYY HH:mm:59"}
                    // value={datapost.timeEnd}
                    placeholder={t("Chọn thời gian")}
                    defaultValue={
                      datapost.timeEnd
                        ? moment(datapost.timeEnd, dateFormat)
                        : null
                    }
                    style={
                      (!datapost.timeEnd ||
                        error.msg ===
                          "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc") &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    showTime
                    onChange={(value, date) => {
                      setDataPost({
                        ...datapost,
                        timeEnd: value.format("YYYY-MM-DD HH:mm:ss"),
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row
                style={{ width: "100%", marginBottom: "1.5rem" }}
                align={"middle"}
                justify={"space-between"}
              >
                <Col span={10}>
                  <LabelInput text={"Đối tượng hiển thị"} />
                </Col>
                <Col span={14}>
                  <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.typePreferential}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          typePreferential: value,
                        });
                      }
                      setDataPost({ ...datapost, typePreferential: value });
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    <Option value={1}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH thuộc đại lý
                      </span>
                    </Option>
                    <Option value={2}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Online
                      </span>
                    </Option>
                    <Option value={3}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                        // onClick={() => setShowSelectGroup(true)}
                      >
                        KH Không bản quyền
                      </span>
                    </Option>
                  </Select>
                </Col>
              </Row>

              <Row
                style={{ width: "100%", marginBottom: "1.5rem" }}
                align={"middle"}
                justify={"space-between"}
              >
                <Col span={10}>
                  <LabelInput text={"Phạm vi hiển thị"} />
                </Col>
                <Col span={14}>
                  <Select
                    className="base"
                    style={
                      error.msg ===
                        "Nhóm khách hàng nhận ưu đãi không xác định" &&
                      error.isError
                        ? { border: "1px solid red", width: "100%" }
                        : { width: "100%" }
                    }
                    defaultValue={0}
                    value={datapost.displayRange}
                    onChange={(value) => {
                      if (value === 0) {
                        setValueSelectUsed([]);
                        setValueSelectValid([]);
                        return setDataPost({
                          ...datapost,
                          attractGroup: [],
                          displayRange: value,
                        });
                      } else {
                        setShowSelectGroup(true);
                        setDataPost({ ...datapost, displayRange: value });
                      }
                    }}
                  >
                    <Option value={0}>
                      <span
                        style={{
                          width: "100%",
                          display: "flex",
                          overflow: "hidden",
                        }}
                        className="labelSelect"
                      >
                        Toàn bộ KH
                      </span>
                    </Option>
                    {datapost.typePreferential !== 3 ? (
                      <Option value={1}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexGrow: 1,
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              width: "100%",
                              display: "flex",
                              overflow: "hidden",
                            }}
                            className="labelSelect"
                          >
                            Nhóm
                          </span>
                          <IconEdit onClick={() => setShowSelectGroup(true)} />
                        </div>
                      </Option>
                    ) : null}
                  </Select>
                </Col>
              </Row>
              {datapost.displayRange ? (
                <>
                  <Row
                    style={{ width: "100%" }}
                    align={"middle"}
                    justify={"space-between"}
                  >
                    <Col span={10}>
                      <LabelInput text={"Số lượng"} />
                    </Col>
                    <Col span={14}>
                      <InputText
                        focus
                        width="100%"
                        typeInput={`${
                          error.msg ===
                          "Bạn nhập sai định dạng. Vui lòng nhập lại"
                            ? "checkEmptyText baseInput"
                            : "baseInput"
                        }`}
                        text={datapost.numberCustomer}
                        placeholder="Nhập số lượng KH nhận thông báo"
                        setText={(value) =>
                          setDataPost({ ...datapost, numberCustomer: value })
                        }
                      />
                    </Col>
                  </Row>
                  <Row
                    style={{ width: "100%" }}
                    align={"middle"}
                    justify={"space-between"}
                  >
                    <Col span={6}></Col>
                    <Col span={18}>
                      <i className="note">
                        (
                        {t(
                          "Nếu không nhập số lượng thì thông báo sẽ gửi cho tất cả khách hàng trong nhóm"
                        )}
                        )
                      </i>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
        </Col>
      </Row>

      {error.isError ? (
        <small className="msgError">{t(error.msg)}</small>
      ) : null}
    </>
  );
};

export default TabDeals;
